<script setup>
import { onMounted, onUnmounted } from 'vue'
// import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import { Link } from '@inertiajs/inertia-vue3'
const props = defineProps({
  categories: Object,
  brandInfo: Array,
  lv4: String,
})

// const getCategoryName = function(){
//   // console.log('props.categories' )
//   // console.log(props.categories )
//   // console.log(props.brandInfo[0].brandCategorySlug )
//   let slugToMatch = cleanExtractCategory()
//   const subcategories = props.categories.filter(i => i.categorySlug == slugToMatch )
//   // console.log('subcategories' )
//   // console.log(subcategories )
//   return (subcategories[0]) ? subcategories[0].categoryNameJ : ''
// }

const cleanExtractCategory = ()=>{
  let r
  if (props.brandInfo[0].brandCategorySlug.includes(',')) {
    const t = props.brandInfo[0].brandCategorySlug.split(',')
    r = t[0]
  } else {
    r = props.brandInfo[0].brandCategorySlug
  }
  return r
}
onMounted(() => {

})
onUnmounted(() => { })
</script>
<template>
  <div class="brand-nav">
    <ul class="brand-links clearfix">
      <li>{{ brandInfo[0].brandNameLocal }}：</li>
      <li>
        <Link :href="'/brands/' + brandInfo[0].brandSlug + '#brand-products'">商品一覧</Link>
      </li>
      <li>
        <Link :href="'/brands/' + brandInfo[0].brandSlug + '#brand-news'">ニュース</Link>
      </li>
      <li><a :href="'/stores/list/page/1?brand=' + brandInfo[0].brandSlug + '&amp;area=&amp;q='" title="取り扱い店舗">取り扱い店舗</a></li>
      <li>
        <a
          class="ecBtn" :href="brandInfo[0].localEcURL" target="_blank"
          title="オンラインストア"
        >オンラインストア</a>
      </li>
    </ul>
  </div>
</template>
